import { usePortalSize } from "@src/Components/Common/usePortalSize"
import { Link } from "@src/Components/Link"
import { Section } from "@src/Components/StyledUtils"
import Tooltip from "@src/Components/Tooltip"
import {
  DateFormat,
  useUserLocaleDateFormatting,
} from "@src/Hooks/useUserLocaleDateFormatting"
import { tState } from "@src/Model/Model"
import Level from "@src/Portal/Zimm/Level"
import { IZimmDashboardData } from "@src/types"
import { useSelector } from "react-redux"

import { SubHeading } from "../styles"
import { DateInfo, ElementTitle, TooltipArea } from "./styles"

interface IFilledState {
  zimmData?: IZimmDashboardData
  isFinished: boolean
}

export const FilledStateCard = ({ zimmData, isFinished }: IFilledState) => {
  const { isLargeScreen } = usePortalSize()
  const { helpCenter } = useSelector((state: tState) => state.brand)
  const { formatDate } = useUserLocaleDateFormatting()

  return (
    <>
      {!isFinished && (
        <SubHeading>Analyze and strengthen your cybersecurity.</SubHeading>
      )}
      {isFinished && (
        <>
          <TooltipArea data-tooltip-id="tooltip-zimm-empty-state">
            <Level level={zimmData?.overallLevel} large cursor="help" />
          </TooltipArea>
          <ElementTitle>{zimmData?.levelInfo?.levelName}</ElementTitle>
          <DateInfo margin={!isLargeScreen ? "42px 0 0" : "3px 0 0"}>
            Updated{" "}
            {formatDate(new Date(zimmData?.lastUpdated), DateFormat.Date)}
          </DateInfo>
          <Tooltip
            offset={-18}
            id="tooltip-zimm-empty-state"
            clickable
            content={
              <Section fontSize="16px" padding="5 10">
                <Section margin="0 0 10 0" fontWeight="700">
                  Level {zimmData?.overallLevel}
                </Section>
                <div>
                  {zimmData?.levelInfo?.description}{" "}
                  <Link
                    href={`https://${helpCenter}/hc/en-us/articles/7793335742487-Cyber-Maturity-Model-and-Levels`}
                    withIcon
                    isUnderline
                  >
                    More
                  </Link>
                </div>
                <br />
                {zimmData?.lastUpdated && (
                  <i>
                    Assessment last updated{" "}
                    {zimmData?.lastUpdated &&
                      formatDate(
                        new Date(zimmData?.lastUpdated),
                        DateFormat.Date,
                      )}
                  </i>
                )}
              </Section>
            }
          />
        </>
      )}
    </>
  )
}
